import type React from 'react';

export const CODE_FONT: React.CSSProperties = {
    color: 'var(--malachite-codeblock-foreground)',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'var(--malachite-font-mono, monospace)',
    textAlign: 'left',
    background: 'transparent',
};


/** Anchored, so prose containing a colon falls through to {@link INDENT_COLUMN} instead. */
const VALUE_COLUMN = /^ *(?:- +)*(?:"[^"]*"|'[^']*'|[^\s:'"][^\s:]*): +(?=\S)/;

const INDENT_COLUMN = /^ *(?:- +)*/;

/**
 * Backstop, not a fit-to-width rule: `padding-left` counts toward the flex item's
 * `min-width: auto`, so a pathological key could otherwise widen the row past its panel. Set
 * well past any realistic key (the deepest in connector step YAML is ~18ch) because a clamped
 * row stops aligning under its value, which is the whole point of the hang.
 */
const MAX_HANG_CH = 32;

/**
 * Hangs a wrapped row under the start of its line's value, so it can't read as a new key.
 * Measured in `ch` — the block is monospace, so one `ch` is one space (tabs are not counted).
 */
export const hangingIndentStyle = (line: string): React.CSSProperties => {
    const column = (VALUE_COLUMN.exec(line) ?? INDENT_COLUMN.exec(line))?.[0].length ?? 0;
    const hang = Math.min(column, MAX_HANG_CH);
    if (hang === 0) {
        return {};
    }
    const hangingIndent = `${hang}ch`;
    return { paddingLeft: hangingIndent, textIndent: `-${hangingIndent}` };
};
